import { render, staticRenderFns } from "./ad_agreement.vue?vue&type=template&id=3796f905&scoped=true&"
import script from "./ad_agreement.vue?vue&type=script&lang=js&"
export * from "./ad_agreement.vue?vue&type=script&lang=js&"
import style0 from "./ad_agreement.vue?vue&type=style&index=0&id=3796f905&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3796f905",
  null
  
)

export default component.exports